// Sue jar-builder adapter for jar-preview-3d.js.
// Classic script. The module may load later, so sync waits for VPJarPreview.
//
// Contract: window.vpJarBuilderPreview.syncJar() / .syncLabels() / .dispose()
// Label builder: VINYLPAC artwork on the CAD jar (customer files stay flat).
// Empty-jar shop: the same CAD jar with no labels.
//
// 10/11 instant intro: when vp-standin.js holds a clip of this exact jar at this stage size, the clip plays
// the jar's intro from the card's first frame while the live jar loads held (VPJarPreview hold); the clip
// then hands over to the live jar on the same frame (VPJarPreview.seekIntro). No clip: the live jar as before.

(function () {
  var JAR_PAGE = {
    'miron-ceres-5ml': 'ceres',
    'miron-eris-5ml-cr': 'eris',
    'black-glass-4oz-cr': 'black4oz',
    'miron-saturn-150ml-cr': 'saturn'
  };

  var DEG = Math.PI / 180;
  var VIEWS = [
    { id: 'angle', label: 'Angle', polar: 68 * DEG, azimuth: 17.5 * DEG },
    { id: 'side', label: 'Side', polar: Math.PI / 2 - 0.12, azimuth: Math.PI / 2 },
    { id: 'top', label: 'Top', polar: 0.28, azimuth: 17.5 * DEG }
  ];
  var PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  // Fixed VINYLPAC renders of each jar at rest (the live viewer's own look(), 10/12): one stage still per spec and one
  // thumbnail per view. The stage rule (syncStage) shows the still whenever the live canvas has nothing real to show;
  // syncThumbs fills the view thumbnails until a clip's or the live jar's own snapshots replace them.
  var STAGE_STILLS = {
    'jl|ceres|wrap0': (window.VP_CDN+"jar-labels__stage__jl-ceres-wrap0.webp?v=6dc624e02c"),
    'jl|eris|wrap0': (window.VP_CDN+"jar-labels__stage__jl-eris-wrap0.webp?v=2241cf24b5"),
    'jl|black4oz|wrap1': (window.VP_CDN+"jar-labels__stage__jl-black4oz-wrap1.webp?v=d6f4b4598c"),
    'jl|saturn|wrap1': (window.VP_CDN+"jar-labels__miron-150ml-vinylpac-lid-wrap.webp?v=1111a0fbb1"),
    'jl|saturn|wrap0': (window.VP_CDN+"jar-labels__miron-150ml-vinylpac-no-lid-wrap.webp?v=5c637e1600"),
    'jars|ceres|bare': (window.VP_CDN+"jar-labels__stage__jars-ceres-bare.webp?v=5846606d83"),
    'jars|eris|bare': (window.VP_CDN+"jar-labels__stage__jars-eris-bare.webp?v=95ca6b5398"),
    'jars|black4oz|bare': (window.VP_CDN+"jar-labels__stage__jars-black4oz-bare.webp?v=0e63a1dcc3"),
    'jars|saturn|bare': (window.VP_CDN+"jar-labels__stage__jars-saturn-bare.webp?v=d27ca87342")
  };
  var VIEW_STILLS = {
    'jl|ceres|wrap0': { angle: (window.VP_CDN+"jar-labels__views__jl-ceres-wrap0-angle.jpg?v=37153d703c"), side: (window.VP_CDN+"jar-labels__views__jl-ceres-wrap0-side.jpg?v=9af3444a3d"), top: (window.VP_CDN+"jar-labels__views__jl-ceres-wrap0-top.jpg?v=83a56ca6e6") },
    'jl|eris|wrap0': { angle: (window.VP_CDN+"jar-labels__views__jl-eris-wrap0-angle.jpg?v=5423ad7872"), side: (window.VP_CDN+"jar-labels__views__jl-eris-wrap0-side.jpg?v=3550d1ea01"), top: (window.VP_CDN+"jar-labels__views__jl-eris-wrap0-top.jpg?v=1311213d7c") },
    'jl|black4oz|wrap1': { angle: (window.VP_CDN+"jar-labels__views__jl-black4oz-wrap1-angle.jpg?v=bbe027e68e"), side: (window.VP_CDN+"jar-labels__views__jl-black4oz-wrap1-side.jpg?v=94aa42bd49"), top: (window.VP_CDN+"jar-labels__views__jl-black4oz-wrap1-top.jpg?v=b19684c919") },
    'jl|saturn|wrap1': { angle: (window.VP_CDN+"jar-labels__views__jl-saturn-wrap1-angle.jpg?v=76fa5f82f4"), side: (window.VP_CDN+"jar-labels__views__jl-saturn-wrap1-side.jpg?v=0fea4f6cbd"), top: (window.VP_CDN+"jar-labels__views__jl-saturn-wrap1-top.jpg?v=0a9c1649c4") },
    'jl|saturn|wrap0': { angle: (window.VP_CDN+"jar-labels__views__jl-saturn-wrap0-angle.jpg?v=9b1b883f9b"), side: (window.VP_CDN+"jar-labels__views__jl-saturn-wrap0-side.jpg?v=6f3918fc66"), top: (window.VP_CDN+"jar-labels__views__jl-saturn-wrap0-top.jpg?v=a9370def46") },
    'jars|ceres|bare': { angle: (window.VP_CDN+"jar-labels__views__jars-ceres-bare-angle.jpg?v=eccf784105"), side: (window.VP_CDN+"jar-labels__views__jars-ceres-bare-side.jpg?v=4dd2010624"), top: (window.VP_CDN+"jar-labels__views__jars-ceres-bare-top.jpg?v=4c59d789ef") },
    'jars|eris|bare': { angle: (window.VP_CDN+"jar-labels__views__jars-eris-bare-angle.jpg?v=384961d1c7"), side: (window.VP_CDN+"jar-labels__views__jars-eris-bare-side.jpg?v=f235435c95"), top: (window.VP_CDN+"jar-labels__views__jars-eris-bare-top.jpg?v=ab3bac68e9") },
    'jars|black4oz|bare': { angle: (window.VP_CDN+"jar-labels__views__jars-black4oz-bare-angle.jpg?v=d82527bf55"), side: (window.VP_CDN+"jar-labels__views__jars-black4oz-bare-side.jpg?v=89a9de5682"), top: (window.VP_CDN+"jar-labels__views__jars-black4oz-bare-top.jpg?v=789302eda4") },
    'jars|saturn|bare': { angle: (window.VP_CDN+"jar-labels__views__jars-saturn-bare-angle.jpg?v=264b97a489"), side: (window.VP_CDN+"jar-labels__views__jars-saturn-bare-side.jpg?v=6a18e2abc5"), top: (window.VP_CDN+"jar-labels__views__jars-saturn-bare-top.jpg?v=84fc060855") }
  };
  function specKey(spec) {
    if (!spec || !spec.jar) return '';
    return spec.labels === false ? 'jars|' + spec.jar + '|bare' : 'jl|' + spec.jar + '|' + (spec.lidWrap ? 'wrap1' : 'wrap0');
  }
  // Once the first live frame is up, this page's other stills come in during idle time, so a jar or Lid wrap switch
  // while the 3D is lost or loading shows its own still at once instead of the previous one for a moment.
  var stillsPreloaded = false;
  function preloadStills() {
    if (stillsPreloaded || typeof Image !== 'function') return;
    stillsPreloaded = true;
    var prefix = labelPage() ? 'jl|' : 'jars|';
    var go = function () {
      Object.keys(STAGE_STILLS).forEach(function (k) { if (k.indexOf(prefix) === 0) { var im = new Image(); im.decoding = 'async'; im.src = STAGE_STILLS[k]; } });
    };
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 1500);
  }
  // What each view button shows is in img.dataset.shows = kind|specKey (kind: live, standin or still), written by
  // whoever sets its src (paintThumbs, vp-standin.js applyThumbs, here). A different jar gets its own still at once,
  // even while the old live jar can still repaint.
  function syncThumbs(spec) {
    var want = specKey(spec), stills = VIEW_STILLS[want];
    if (!stills) return;
    var buttons = document.querySelectorAll('[data-jar-view]');
    for (var i = 0; i < buttons.length; i++) {
      var img = buttons[i].querySelector('img'), src = stills[buttons[i].dataset.jarView];
      if (!img || !src || !img.dataset) continue;
      var shows = (img.dataset.shows || '').split('|'), kind = shows[0], key = shows.slice(1).join('|');
      if (key === want && (kind === 'live' || kind === 'standin' || kind === 'still')) continue;
      img.src = src;
      img.dataset.shows = 'still|' + want;
      delete img.dataset.thumbKey;
    }
  }
  var mountedCanvas = null;
  var lastKey = '';
  var lastModelKey = '';
  var waiting = false;
  var waitTimer = null;
  var thumbTimer = null;
  var thumbGen = 0;
  var failed = false;
  var scheduled = false;
  var standinDecided = false;   // vp-standin.js made its one decision for this page
  var gaveUp = false;           // no 3D module after 20 s: the box went back to the photo (a late module still applies)
  var sessionGen = 0, applyGen = 0, syncGen = 0;
  var retryTimer = null, retryCount = 0, failedKey = '', recoveryPose = null;
  var thumbWork = null, thumbWorkIdle = false;
  var flushedModel = '';        // the jar the last update showed (a different one = a jar switch)

  function liveShowing() {
    var s = window.VPJarPreview && window.VPJarPreview.introState ? window.VPJarPreview.introState() : null;
    return !!(s && s.visible);
  }

  function standin() { return window.VPStandin || null; }
  function labelPage() { return !!document.getElementById('jl-photo-view'); }

  function pressed(selector, key) {
    var button = document.querySelector(selector + ' [aria-pressed="true"]');
    return button ? button.dataset[key] || '' : '';
  }

  function labelModel() {
    var id = pressed('#jl-products', 'jar');
    if (id === 'black-4oz') return 'black4oz';
    if (id === 'miron-150ml') return 'saturn';
    if (id === 'miron-5ml-eris') return 'eris';
    if (id === 'miron-5ml-ceres') return 'ceres';
    return '';
  }

  function labelFinish() {
    var finish = pressed('#jl-finishes', 'finish');
    var tier = pressed('#jl-tiers', 'tier');
    var embossName = pressed('#jl-embosses', 'emboss');
    var material = { Holographic: 'holo', Chrome: 'chrome', Gold: 'gold', Glitter: 'glitter' }[finish] || 'gloss';
    var emboss = tier === 'Premium Tier Embossing' ? 'heavy' : tier === 'Standard Tier Embossing' ? 'std' : 'none';
    // Flat labels pick Gloss or Matte as their material (Josh 10/17); embossed ones by the emboss finish.
    var laminate = embossName === 'Matte' || finish === 'Matte' ? 'matte' : 'gloss';
    var white = material !== 'gloss' && pressed('#jl-whites', 'whiteInk') !== 'Spot white' ? 'none' : 'spot';
    return { material: material, laminate: laminate, emboss: emboss, white: white };
  }

  function payload() {
    var photo = document.getElementById('jl-photo-view');
    if (photo) {
      if (photo.hidden) return null;
      var jar = labelModel();
      if (!jar) return null;
      var finish = labelFinish();
      var lidWrap = document.getElementById('jl-ring');
      return {
        jar: jar,
        labels: true,
        // data-preview=on: the 4oz/150ml intro wears the Lid wrap before its switch flips on (jar-labels.js).
        lidWrap: !lidWrap || lidWrap.checked || lidWrap.dataset.preview === 'on',
        material: finish.material,
        laminate: finish.laminate,
        emboss: finish.emboss,
        white: finish.white
      };
    }
    var card = document.querySelector('#jarsProdGrid .jar-card.active, #jarsProdGrid .jar-card[aria-pressed="true"]');
    var model = card && JAR_PAGE[card.dataset.jar];
    if (!model) return null;
    // Empty-jar shop: bare glass, no label artwork.
    return { jar: model, labels: false };
  }

  function host() {
    if (document.getElementById('jl-photo-view')) return document.querySelector('#jl-photo-view .jl-photo');
    return document.querySelector('.jar-detail-img-wrap');
  }

  function viewAngles(view, spec) {
    if (view.id === 'side' || !spec || !window.VPJarPreview?.frontAzimuth) return view;
    return { polar: view.polar, azimuth: window.VPJarPreview.frontAzimuth(spec.jar, spec.labels) };
  }

  function showView(id) {
    var view = null;
    for (var i = 0; i < VIEWS.length; i++) if (VIEWS[i].id === id) view = VIEWS[i];
    if (!view) return;
    var buttons = document.querySelectorAll('[data-jar-view]');
    for (var j = 0; j < buttons.length; j++) {
      var on = buttons[j].dataset.jarView === id;
      buttons[j].setAttribute('aria-pressed', on ? 'true' : 'false');
      buttons[j].classList.toggle('active', on);
    }
    if (window.VPJarPreview && typeof window.VPJarPreview.look === 'function') {
      var angles = viewAngles(view, payload());
      window.VPJarPreview.look(angles.polar, angles.azimuth);
    }
  }

  function pickView(id) {
    // A picked view while the intro clip plays: the live jar takes over first (when it is ready).
    var s = standin();
    if (s && s.active()) s.userAction('view');
    showView(id);
    syncStage();
  }

  function makeViewButton(view, className, pressedId) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.dataset.jarView = view.id;
    button.setAttribute('aria-label', view.label + ' view');
    var on = view.id === pressedId;
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.classList.toggle('active', on);
    var img = document.createElement('img');
    img.alt = '';
    img.width = 55;
    img.height = 55;
    img.src = PLACEHOLDER;
    button.appendChild(img);
    button.addEventListener('click', function () { pickView(view.id); });
    return button;
  }

  function ensureViews() {
    var box = document.getElementById('jl-thumbnails');
    var className = 'jl-thumbnail';
    if (!box) {
      var wrap = document.querySelector('.jar-detail-img-wrap');
      if (!wrap || !wrap.parentNode) return;
      box = wrap.parentNode.querySelector('#jar-view-thumbs');
      if (!box) {
        box = document.createElement('div');
        box.id = 'jar-view-thumbs';
        box.className = 'jar-thumb-row';
        box.setAttribute('role', 'group');
        box.setAttribute('aria-label', 'Jar views');
        wrap.insertAdjacentElement('afterend', box);
      }
      className = 'jar-thumb-btn';
    }
    var existing = box.querySelectorAll('[data-jar-view]');
    if (existing.length === VIEWS.length && VIEWS.every(function (view, index) { return existing[index].dataset.jarView === view.id; })) return;
    var current = box.querySelector('[data-jar-view][aria-pressed="true"]');
    var pressedId = current ? current.dataset.jarView : 'angle';
    box.replaceChildren();
    VIEWS.forEach(function (view) { box.appendChild(makeViewButton(view, className, pressedId)); });
  }

  // Thumbnails already drawn by the live jar for this exact spec (each <img> carries the spec it shows).
  function thumbsPainted(key) {
    var imgs = document.querySelectorAll('[data-jar-view] img');
    if (!imgs.length) return false;
    for (var i = 0; i < imgs.length; i++) if (!imgs[i].dataset || imgs[i].dataset.thumbKey !== key) return false;
    return true;
  }

  function paintThumbs(gen, spec, shots) {
    if (gen !== thumbGen || !window.VPJarPreview || typeof window.VPJarPreview.snapshot !== 'function') return false;
    var captured = shots;
    shots = shots || {};
    for (var i = 0; !captured && i < VIEWS.length; i++) {
      var angles = viewAngles(VIEWS[i], spec);
      var url = window.VPJarPreview.snapshot(angles.polar, angles.azimuth);
      if (!url) return false;
      shots[VIEWS[i].id] = url;
    }
    if (gen !== thumbGen) return false;
    var key = JSON.stringify(spec);
    var buttons = document.querySelectorAll('[data-jar-view]');
    for (var j = 0; j < buttons.length; j++) {
      var img = buttons[j].querySelector('img');
      if (img && shots[buttons[j].dataset.jarView]) { img.src = shots[buttons[j].dataset.jarView]; if (img.dataset) { img.dataset.thumbKey = key; img.dataset.shows = 'live|' + specKey(spec); } }
    }
    // The product strip keeps its fixed per-jar renders (jar-labels.js); only the view thumbnails follow the live jar.
    var canvas = document.getElementById('jar-builder-3d');
    if (canvas) canvas.dispatchEvent(new CustomEvent('jarthumbs', { detail: { key: key } }));
    return true;
  }

  function stopThumbs() {
    thumbGen += 1;
    clearInterval(thumbTimer);
    thumbTimer = null;
    if (thumbWork !== null) {
      if (thumbWorkIdle) { if (window.cancelIdleCallback) window.cancelIdleCallback(thumbWork); }
      else clearTimeout(thumbWork);
      thumbWork = null;
    }
  }

  function refreshThumbs(spec, force) {
    if (!force && thumbsPainted(JSON.stringify(spec))) return;
    stopThumbs();
    var gen = thumbGen, n = 0;
    function tick() {
      if (gen !== thumbGen || JSON.stringify(payload()) !== JSON.stringify(spec)) return true;
      var canvas = document.getElementById('jar-builder-3d');
      var diag = window.jarArtworkDiagnostics ? window.jarArtworkDiagnostics() : null;
      var ready = canvas && !canvas.hidden && canvas.dataset.state === 'ready' &&
        window.VPJarPreview && window.VPJarPreview.ready() &&
        diag && diag.jar === spec.jar && diag.status === 'ready';
      if (!ready) return false;
      // Snapshot work stays out of the option-change task and yields between views.
      var shots = {}, index = 0;
      function draw() {
        if (gen !== thumbGen) return;
        thumbWork = null;
        if (JSON.stringify(payload()) !== JSON.stringify(spec)) return;
        try {
          if (!window.VPJarPreview.ready()) return;
          var view = VIEWS[index], angles = viewAngles(view, spec);
          var url = window.VPJarPreview.snapshot(angles.polar, angles.azimuth);
          if (!url) return;
          shots[view.id] = url;
          if (++index < VIEWS.length) { scheduleDraw(); return; }
          paintThumbs(gen, spec, shots);
        } catch (error) { console.warn('jar-builder-preview thumbnails', error); }
      }
      function scheduleDraw() {
        thumbWorkIdle = !!window.requestIdleCallback;
        if (thumbWorkIdle) thumbWork = window.requestIdleCallback(draw, { timeout: 500 });
        else thumbWork = setTimeout(draw, 0);
      }
      scheduleDraw();
      return true;
    }
    thumbTimer = setInterval(function () {
      n += 1;
      if (tick() || n > 200 || gen !== thumbGen) {
        clearInterval(thumbTimer);
        thumbTimer = null;
      }
    }, 50);
  }

  // THE stage rule (10/12 review, round 3), one function, re-run on every transition: viewer state changes
  // (jarpreviewstate: loss, grace expiry, restore, first real frame, jar switch), clip attach / hand-off / cancel /
  // freeze (vpstandinchange), every spec or view change (flush, pickView, apply) and page visibility. The live canvas
  // shows only while no clip covers it (a covering clip keeps it in place for the hand-off frame), the WebGL context
  // is not lost or lost for under the viewer's grace, and the current jar has drawn a real frame since the last
  // boot, loss, restore or jar switch (VPJarPreview.canvasState). Otherwise the fixed VINYLPAC still for the current
  // spec shows under it (#jar-builder-still). Visibility only: the viewer keeps its size and keeps drawing.
  function syncStage() {
    var spec = payload(), key = specKey(spec);
    var still = document.getElementById('jar-builder-still');
    if (still && STAGE_STILLS[key] && still.dataset.key !== key) { still.dataset.key = key; still.src = STAGE_STILLS[key]; }
    var canvas = document.getElementById('jar-builder-3d');
    if (!canvas) return;
    var s = standin(), clip = !!(s && s.active());
    var cs = window.VPJarPreview && window.VPJarPreview.canvasState ? window.VPJarPreview.canvasState() : null;
    var live = !failed && !gaveUp && mountedCanvas === canvas && !!cs && (!spec || !cs.jar || cs.jar === spec.jar) && cs.alive !== false && cs.drawn && (!cs.lost || !cs.graceOver);
    var on = clip || live;
    if (live) preloadStills();
    canvas.style.visibility = on ? '' : 'hidden';
    var hint = document.getElementById('jar-builder-3d-hint');
    if (hint) {
      var finish = typeof window.jarFinishDiagnostics === 'function' ? window.jarFinishDiagnostics() : null;
      var matches = spec && spec.emboss && spec.emboss !== 'none' && cs && cs.jar === spec.jar &&
        finish && finish.options && finish.options.emboss === spec.emboss;
      var fields = matches && finish.meshes || [];
      var unavailable = fields.some(function (mesh) { return mesh.field && (mesh.field.status === 'error' || mesh.field.error); });
      var loading = !unavailable && matches && fields.some(function (mesh) {
        return mesh.field && (mesh.field.status === 'idle' || mesh.field.status === 'building' || mesh.field.slow);
      });
      hint.textContent = unavailable ? 'Embossing preview unavailable · tap to retry' : loading ? 'Loading embossing…' : 'drag to rotate';
      hint.style.visibility = on ? '' : 'hidden';
      hint.style.pointerEvents = unavailable ? 'auto' : '';
      hint.style.cursor = unavailable ? 'pointer' : '';
      if (unavailable) { hint.setAttribute('role', 'button'); hint.setAttribute('tabindex', '0'); }
      else { hint.removeAttribute('role'); hint.removeAttribute('tabindex'); }
      hint.onclick = unavailable ? function () { retryCount = 0; recover(); } : null;
      hint.onkeydown = unavailable ? function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); retryCount = 0; recover(); }
      } : null;
    }
  }

  // reason 'failed': the live jar can't show (WebGL error). An intro clip that is playing keeps its dressed
  // frame instead of leaving a blank box; any other reason removes the clip and releases the live jar.
  function hideStage(reason) {
    var s = standin();
    if (s && s.active()) {
      if (reason === 'failed') s.freeze(); else s.cancel(reason || 'hidden');
    }
    var canvas = document.getElementById('jar-builder-3d');
    var hint = document.getElementById('jar-builder-3d-hint');
    if (canvas) canvas.hidden = true;
    if (hint) hint.hidden = true;
  }

  function ensureStage(wrap, spec) {
    wrap.classList.add('jar-3d-host');
    // The fixed still for the current spec lives under the canvas (syncStage picks it and decides which one shows).
    var still = document.getElementById('jar-builder-still');
    if (!still) {
      still = document.createElement('img');
      still.id = 'jar-builder-still';
      still.alt = '';
      still.decoding = 'async';
      wrap.appendChild(still);
    } else if (still.parentNode !== wrap) {
      wrap.appendChild(still);
    }
    var canvas = document.getElementById('jar-builder-3d');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'jar-builder-3d';
      canvas.setAttribute('aria-label', 'Interactive jar preview');
      // The raised relief can finish after the first thumbnails; repaint them when it lands.
      canvas.addEventListener('jarfinishchange', function () {
        var spec = payload();
        if (spec && mountedCanvas === canvas) { syncStage(); refreshThumbs(spec, true); }
      });
      // The live jar died on its own (jar-preview-3d.js die(): a boot or frame error): same as a failed mount, so a
      // playing clip keeps its dressed frame and otherwise the fixed VINYLPAC still under the canvas shows, never
      // a dead white box (10/12).
      canvas.addEventListener('jarpreviewdead', function () {
        if (mountedCanvas !== canvas || failed) return;
        failSession();
      });
      canvas.addEventListener('webglcontextrestored', function () {
        var gen = syncGen;
        setTimeout(function () {
          if (gen === syncGen && failed && payload()) { retryCount = 0; recover(); }
        }, 0);
      });
      // A restore can arrive after the thumbnail polling window ended.
      canvas.addEventListener('jarpreviewstate', function () {
        syncStage();
        var spec = payload();
        if (spec && !failed && mountedCanvas === canvas && !thumbTimer && thumbWork === null &&
            window.VPJarPreview && window.VPJarPreview.ready()) refreshThumbs(spec);
      });
      wrap.appendChild(canvas);
    } else if (canvas.parentNode !== wrap) {
      wrap.appendChild(canvas);
    }
    var hint = document.getElementById('jar-builder-3d-hint');
    if (!hint) {
      hint = document.createElement('div');
      hint.id = 'jar-builder-3d-hint';
      hint.textContent = 'drag to rotate';
      wrap.appendChild(hint);
    } else if (hint.parentNode !== wrap) {
      wrap.appendChild(hint);
    }
    if (spec) {
      hint.textContent = 'drag to rotate';
      hint.title = '';
    }
    canvas.hidden = false;
    hint.hidden = false;
    ensureViews();
    return canvas;
  }

  function failSession(error) {
    if (failed) return;
    failed = true;
    failedKey = JSON.stringify(payload());
    applyGen += 1;
    stopThumbs();
    var live = window.VPJarPreview;
    try { recoveryPose = live && live.pose ? live.pose() : null; } catch (ignored) {}
    hideStage('failed');
    syncStage();
    if (error) console.warn('jar-builder-preview', error);
    // One automatic retry; further attempts need a new selection, online event or explicit retry.
    if (retryCount < 1) {
      var gen = sessionGen;
      retryCount += 1;
      retryTimer = setTimeout(function () {
        retryTimer = null;
        if (failed && gen === sessionGen && payload()) recover();
      }, 1000);
    }
  }

  function recover(deferApply) {
    clearTimeout(retryTimer); retryTimer = null;
    sessionGen += 1; applyGen += 1;
    stopThumbs();
    var s = standin();
    if (s && s.active()) s.cancel('retry');
    if (window.VPJarPreview && window.VPJarPreview.dispose) {
      try { window.VPJarPreview.dispose(); } catch (ignored) {}
    }
    mountedCanvas = null;
    lastKey = '';
    failed = gaveUp = false;
    if (!deferApply) waitAndApply();
  }

  function apply() {
    if (failed) return;
    ensureViews();
    var spec = payload(), wrap = host(), live = window.VPJarPreview;
    if (!spec || !wrap || !live) {
      if (!spec) hideStage('hidden');
      return;
    }
    gaveUp = false;
    var canvas = ensureStage(wrap, spec);
    if (mountedCanvas !== canvas) {
      sessionGen += 1;
      mountedCanvas = canvas;
      lastKey = '';
    }
    var key = JSON.stringify(spec), gen = ++applyGen, session = sessionGen;
    function current() {
      return gen === applyGen && session === sessionGen && mountedCanvas === canvas &&
        window.VPJarPreview === live && JSON.stringify(payload()) === key;
    }
    try {
      if (key !== lastKey) {
        var s = standin(), hold = !!(s && s.holdFor(spec));
        live.set(Object.assign({}, spec, { hold: hold, fromStill: !hold }));
      }
      var pending = live.mount(canvas);
      if (key !== lastKey) {
        var modelKey = spec.jar + ':' + spec.labels;
        if (modelKey !== lastModelKey) {
          recoveryPose = null;
          var selected = document.querySelector('[data-jar-view][aria-pressed="true"]');
          showView(selected ? selected.dataset.jarView : 'angle');
          lastModelKey = modelKey;
        }
        lastKey = key;
      }
      function settled() {
        if (!current() || failed) return;
        if (canvas.dataset.state === 'error') { failSession(); return; }
        if (recoveryPose && live.restorePose) { live.restorePose(recoveryPose); recoveryPose = null; }
        syncStage();
        refreshThumbs(spec);
      }
      if (pending && typeof pending.then === 'function') {
        Promise.resolve(pending).then(settled).catch(function (error) { if (current()) failSession(error); });
      }
      refreshThumbs(spec);
      syncStage();
    } catch (error) { if (current()) failSession(error); }
  }

  function stopWaiting() {
    waiting = false;
    clearInterval(waitTimer);
    waitTimer = null;
  }

  function waitAndApply() {
    if (window.VPJarPreview) {
      stopWaiting();
      apply();
      return;
    }
    if (waiting || gaveUp) return;
    waiting = true;
    var n = 0;
    waitTimer = setInterval(function () {
      n += 1;
      if (window.VPJarPreview) {
        stopWaiting();
        apply();
      } else if (n > 400 && !(standin() && standin().active())) {
        // No 3D after 20 s: give the box back to the photo (a late module still applies, see below). While an opening
        // clip shows the jar (a very slow link), it keeps waiting: the box isn't empty.
        stopWaiting();
        gaveUp = true;
        hideStage('timeout');
      }
    }, 50);
  }

  // vp-standin.js loads async and may arrive after the page's first jar: it can still attach (before the jar shows).
  window.addEventListener('vpstandin', function () { if (!standinDecided && payload()) sync(); });
  // Clip transitions (attach, hand-off, cancel, freeze) and page visibility re-run the stage rule and the thumbnails.
  window.addEventListener('vpstandinchange', function () { syncThumbs(payload()); syncStage(); });
  if (typeof document.addEventListener === 'function') document.addEventListener('visibilitychange', syncStage);

  // The 3D module announces itself (it loads async), so the jar starts without waiting for the next poll.
  window.addEventListener('vpjarpreview', function () {
    if (failed && payload()) { retryCount = 0; recover(); return; }
    if (!waiting && !mountedCanvas && !failed && payload()) { waiting = true; }
    if (waiting) { stopWaiting(); apply(); }
  });

  function dispose() {
    clearInterval(waitTimer);
    stopThumbs();
    clearTimeout(retryTimer); retryTimer = null;
    sessionGen += 1; applyGen += 1; syncGen += 1;
    failed = gaveUp = scheduled = false; retryCount = 0; recoveryPose = null;
    waitTimer = null;
    waiting = false;
    if (window.VPJarPreview && typeof window.VPJarPreview.dispose === 'function') {
      try { window.VPJarPreview.dispose(); } catch (error) {}
    }
    mountedCanvas = null;
    lastKey = '';
    lastModelKey = '';
    flushedModel = '';
    hideStage('disposed');
    syncStage();
  }

  // One update per task: the label page notifies twice while it renders one product (gallery, then
  // options) and only the final state counts. Microtasks run before the page paints.
  function flush() {
    scheduled = false;
    var spec = payload();
    var wrap = host();
    var s = standin();
    syncThumbs(spec);
    if (failed && spec && JSON.stringify(spec) !== failedKey) { retryCount = 0; recover(true); }
    if (failed) {
      // No live jar: a frozen clip frame only stays while it still shows the chosen jar and finish.
      if (s && s.active()) s.update(spec);
      syncStage();
      return;
    }
    if (spec && wrap) {
      var model = spec.jar + ':' + spec.labels, switched = !!flushedModel && model !== flushedModel;
      flushedModel = model;
      if (!standinDecided && s && !liveShowing()) {
        // Decided once, on the page's first jar, and never over a live jar that already shows.
        standinDecided = true;
        s.attach(wrap, spec);
      } else if (s) {
        if (s.active()) s.update(spec);   // another jar drops the clip
        // A jar switch: the new jar loads hidden and opens with its intro like a page open, so it gets its own clip.
        if (switched && !s.active() && s.reattach) s.reattach(wrap, spec);
      }
      // The label page's stage is white from the card's first frame (the module may still be loading);
      // the jar shop keeps its photo until the 3D, unless a clip is playing over it. Once the 3D has been given up
      // on, the photo stays (a late module still brings the 3D through apply()).
      if ((labelPage() && !gaveUp) || (s && s.active())) ensureStage(wrap, spec);
    } else if (s && s.active()) {
      s.cancel('no-jar');
    }
    waitAndApply();
    syncStage();
  }

  function sync() {
    ensureViews();
    if (scheduled) return;
    scheduled = true;
    var gen = syncGen;
    function run() {
      if (gen !== syncGen) return;
      try { flush(); } catch (error) { failSession(error); }
    }
    if (typeof queueMicrotask === 'function') queueMicrotask(run);
    else Promise.resolve().then(run);
  }

  window.vpJarBuilderPreview = {
    syncJar: sync,
    syncLabels: sync,
    dispose: dispose,
    retry: function () { retryCount = 0; recover(); },
    spec: function () { return payload(); }   // read-only: the viewer spec the page shows now
  };

  window.addEventListener('online', function () { if (failed && payload()) { retryCount = 0; recover(); } });

  window.addEventListener('load', function () {
    if (window.vpJarBuilderPreview) window.vpJarBuilderPreview.syncJar();
  });
})();
